import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TaskManagementDetailDialogModel} from '../task-management-dialog/task-management-dialog.component';
import {TdoUserGroupConfigurationModel} from '../../../models/configuration/user/tdo-user-group-configuration.model';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';

@Component({
  selector: 'app-task-user-selection-dialog',
  templateUrl: './task-user-selection-dialog.component.html',
  styleUrls: ['./task-user-selection-dialog.component.scss']
})
export class TaskUserSelectionDialogComponent implements OnInit {
  isOnlyShowUsersInSelectedGroup = false;
  selectedUserGroup: TdoUserGroupConfigurationModel;
  selectedUser: TdoUserConfigurationModel;
  hoveredUser: TdoUserConfigurationModel;
  userList: TdoUserConfigurationModel[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: TaskManagementDetailDialogModel,
              private dialogRef: MatDialogRef<TaskUserSelectionDialogComponent>) {
    if (data.model.ForUserGroupID) {
      this.selectedUserGroup = data.userGroups.find(p => p.UserGroupId === data.model.ForUserGroupID);
    }

    if (data.isAssignToUserDialog) {
      if (data.model.AssignedToUserID) {
        this.selectedUser = data.users.find(p => p.UserID === data.model.AssignedToUserID);
      }
    } else {
      if (data.model.ForUserID) {
        this.selectedUser = data.users.find(p => p.UserID === data.model.ForUserID);
      }
    }

    this.userList = this.data.users;
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.selectedUser.UserID);
  }

  onItemMouseOver(user: TdoUserConfigurationModel) {
    this.hoveredUser = user;
  }

  onItemMouseOut(user: TdoUserConfigurationModel) {
    this.hoveredUser = null;
  }

  onItemClick(user: TdoUserConfigurationModel) {
    if (this.selectedUser === user) {
      this.selectedUser = null;
    } else {
      this.selectedUser = user;
    }
  }

  onUserGroupChange(selectedUserGroup: TdoUserGroupConfigurationModel) {
    const groupUserIds = selectedUserGroup.cfgTDOUserInGroups.map(p => p.UserID);
    this.userList = this.data.users.filter(p => groupUserIds.includes(p.UserID));
  }

  onAllGroupChange() {
    this.userList = this.data.users;
  }
}
